







































































import { Vue, Component, Prop } from "@/shared/vuepack";
import AccountBalanceWidget from "@/shared/widgets/AccountBalanceWidget.vue";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import { AuthenticationProvider, Permission } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import AccountHolderInvestment from "./AccountHolderInvestment.vue";
import AccountHolderBilling from "./AccountHolderBilling.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import AccountHolderDependents from "@/employer/components/partner-ee-service/v2/AccountHolderDependents.vue";
import AccountHolderBeneficiaries from "./AccountHolderBeneficiaries.vue";
import AccountHolderAuthorizedSigners from "@/employer/components/partner-ee-service/v2/AccountHolderAuthorizedSigners.vue";
import AccountHolderCredentials from "@/employer/components/partner-ee-service/v2/AccountHolderCredentials.vue";
import AccountHolderDetails from "@/employer/components/partner-ee-service/v2/AccountHolderDetails.vue";
import AccountHolderUserSystemId from "@/employer/components/partner-ee-service/v2/AccountHolderUserSystemId.vue";

@Component({
  components: {
    AccountBalanceWidget,
    ContributionsGraphWidget,
    AccountHolderInvestment,
    AccountHolderBilling,
    AccountHolderDependents,
    AccountHolderBeneficiaries,
    AccountHolderAuthorizedSigners,
    AccountHolderCredentials,
    AccountHolderDetails,
    AccountHolderUserSystemId
  }
})
export default class extends Vue {
  rolePermissionStore = useRolePermissionsStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop ()
  username: string;

  @Prop ()
  partnerId: number;

  @Prop()
  routeToContributions: Location;

  canEditProfile = false;

  get hasAccountInfoReadPermision () {
    return this.rolePermissionStore.userHasPartnerPermission(Permission.HsaAccountInfoRead, this.partnerId);
  }

  get displayAccountHolderBilling () {
    return !this.custodianSettingsStore.isHsaBankCustodian && this.hasAccountInfoReadPermision;
  }

  handleCredentialsLoaded (profile: any) {
    if (profile) {
      this.canEditProfile = (profile.status === "staged" || profile.isCredentialed === false) &&
        profile.provider === AuthenticationProvider.Okta;
    }
  }
}
